<template>
  <div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
            <label>Empresa destino</label>
            <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                @change="listarCentrosCustos"/>
        </div>                
    </div> 
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
            <label>Centro de custo destino</label>
            <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Selecione"
                dataKey="keyRefId" :filter="true" :showClear="true"/>
        </div>                     
    </div>    
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
            <label for="contrato">Data para ativação</label>
            <div class="p-inputgroup">		
                <span class="p-inputgroup-addon">
                    <Checkbox v-model="agendarAtivacao" :binary="true" />
                </span>
                <InputText v-model="dataAtivacaoSelecionada" readonly :disabled="!agendarAtivacao" @click="selecionarExibirDataAtivacao"/>
            </div>														
        </div>
    </div>

    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
            <label>Funcionários</label>
            <Listbox :options="funcionarios" optionLabel="nome" listStyle="height:250px" />
        </div>                     
    </div> 

    <Button label="Cancelar" class="p-button-danger" icon="pi pi-times" @click="limparDados" :disabled="!dadosTransferencia"/>
    <Button label="Transferir" class="p-ml-2" icon="pi pi-check" @click="transferir"/>

    <Dialog :visible.sync="exibirDialogDataAtivacao" header="Data para Ativação" :modal="true" :style="{width: '400px'}">			
        <div class="p-fluid p-formgrid p-grid">	
            <div class="p-field p-col-12 p-md-12">	
                <p>Selecione uma data para ativação do(s) funcionário(s).</p>
                <p id="pLimitesDataAtivacao">Limites: {{ limitesDataAtivacao() }}</p>				
                <Calendar v-model="dataAtivacao" :showIcon="true" :manualInput="false" 
                    dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>	
            </div>				
        </div>
        <template #footer>				
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogDataAtivacao=false"></Button>
            <Button label="OK" icon="pi pi-check" @click="selecionarDataAtivacao"></Button>			
        </template>
    </Dialog>

  </div>

</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import AfastamentoService from '@/service/AfastamentoService';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    afastamentoService: null,
    centroCustoService: null,
    data() {
        return {         
            localeCalendarBR: localeCalendarBR,
            exibirDialogDataAtivacao: false,
            agendarAtivacao: false,  
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            cnpjs: [],
            centrosCustos: [],     
            funcionarios: [],      
            dadosTransferencia: null,
            dataAtivacao: new Date(),
            dataAtivacaoSelecionada: ''
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']), 
        ...mapGetters('funcionario', ['getDadosTransferencia']),    
        ...mapActions('funcionario', ['limparDadosTransferencia']),
        transferir() {
            if(this.dadosTransferencia == null) {
                exibirMensagemSis(this, 'Nenhum funcionário selecionado para transferência', true);
                return;
            }
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Seleciona a empresa de destino', true);
                return;
            }
            let idsFuncionarios = [];
            this.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let cnpj = null;
            for(let i = 0; i < this.cnpjs.length; i++) {
                if(this.idCnpjSelecionado == this.cnpjs[i].id) {
                    cnpj = {...this.cnpjs[i]};
                }
            }
            let centroCusto = null;
            for(let i = 0; i < this.centrosCustos.length; i++) {
                if(this.idCentroCustoSelecionado == this.centrosCustos[i].id) {
                    centroCusto = {...this.centrosCustos[i]};
                }
            }            
            let requisicao = {     
                agendarAtivacao: this.agendarAtivacao,        
                idsFuncionarios: idsFuncionarios,
                motivo: {...this.dadosTransferencia.motivo},       
                dataAtivacao: this.formatarData(this.dataAtivacao),
                dataFinal: this.formatarData(this.dadosTransferencia.dataFinal),
                cnpj: cnpj,
                centroCusto: centroCusto,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
            this.afastamentoService.transferir(requisicao)
            .then(resp => {
                this.limparDados();   
                this.dadosTransferencia = null;             
                exibirMensagem(this, resp);                  
            })
            .catch(erro => {exibirMensagem(this, erro)});            
        },              	        
        listarCnpjs() {            
            if(this.cnpjs.length > 0) {
                return
            }
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
        },
        listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {                    
                let dataKey = 1;               
                resp.data.forEach(ct => {
                    ct['keyRefId'] = dataKey++;
                }); 
                this.centrosCustos = resp.data;
                this.idCentroCustoSelecionado = this.centrosCustos[0].id;                
            })
            .catch(erro => {exibirMensagem(this, erro)});
        }, 
        prepararTransferencia() {
            this.listarCnpjs();
            this.dadosTransferencia = this.getDadosTransferencia();            
            if(this.dadosTransferencia != null) {
                this.funcionarios = this.dadosTransferencia.funcionarios;
            }
        },
        selecionarDataAtivacao() {	
			let umDia = 86400000;
			let hoje = new Date((new Date().getTime() + umDia));			 		
			let limite = new Date((new Date().getTime() + (umDia * 6)));
			hoje.setHours(0,0,0,0);
			limite.setHours(0,0,0,0);			
			this.dataAtivacao.setHours(0,0,0,0);
			limite.setDate(hoje.getDate() + 5);
			if(this.dataAtivacao.getTime() < hoje.getTime() || this.dataAtivacao.getTime() > limite.getTime()) {
				if(document.getElementById('pLimitesDataAtivacao')) {
					document.getElementById('pLimitesDataAtivacao').classList.add('ik-text-danger');
				}
				return;
			}				
			let dt = this.dataAtivacao;
			let mes = dt.getMonth();
			let dia = dt.getDate();
			this.dataAtivacaoSelecionada = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + dt.getFullYear();			
			this.exibirDialogDataAtivacao = false;
		},
		limitesDataAtivacao() {
			let umDia = 86400000;
			let hoje = new Date((new Date().getTime() + umDia));			 		
			let setDias = new Date((new Date().getTime() + (umDia * 6)));
			let mes = hoje.getMonth();
			let dia = hoje.getDate();
			let dataDe = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + hoje.getFullYear();		
			mes = setDias.getMonth();
			dia = setDias.getDate();
			let dataAte = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + setDias.getFullYear();
			return dataDe + ' - ' + dataAte;
		},		
		formatarDataAtivacao() {
			let amanha = new Date();
			amanha.setDate(amanha.getDate() + 1);				
			this.dataAtivacao = amanha;
			let dt = this.dataAtivacao;
			let mes = dt.getMonth();
			let dia = dt.getDate();
			this.dataAtivacaoSelecionada = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + dt.getFullYear();	
		},
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        limparDados() {
            this.limparDadosTransferencia();
            this.dadosTransferencia = null;
            this.funcionarios = [];
            exibirMensagemSis(this, 'Sucesso', false);
        },   
        selecionarExibirDataAtivacao() {
			if(this.agendarAtivacao) {
				this.exibirDialogDataAtivacao = true;
			}
		},  
    },
    created() {
        this.afastamentoService = new AfastamentoService();
        this.centroCustoService = new CentroCustoService();     
        this.formatarDataAtivacao();
    },
    mounted() {
        this.formatarDataAtivacao();
    }    
}
</script>

<style>

</style>